// React
import React from "react";

// MUI
import { Box, Typography } from "@material-ui/core";

const NotFoundPage = () => (
  <Box display="flex" justifyContent="center" align-items="center">
    <Typography>404 Page Not Found</Typography>
  </Box>
);

export default NotFoundPage;
